import { useEffect, useState } from 'react';
import { ref, onValue } from 'firebase/database';
import { rtdb } from '../firebase';

export default function useUserOnlineStatus(userId) {
  const [online, setOnline] = useState(false);
  useEffect(() => {
    if (!userId) return;
    const statusRef = ref(rtdb, `status/${userId}/online`);
    const unsubscribe = onValue(statusRef, (snapshot) => {
      setOnline(snapshot.val() === true);
    });
    return () => unsubscribe();
  }, [userId]);
  return online;
} 